import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useParams } from 'react-router';
import { useNotification } from '@/context/notification';
import { useDecidedRefundRequest } from '@/data/subsidy/refund-requests/decide';

export type ConfirmRefundRequestApproveDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const ConfirmRefundRequestApproveDialog = ({ open, onClose, }: ConfirmRefundRequestApproveDialogProps) => {
  const [comment, setComment] = useState('');
  const { refund_request_uuid } = useParams();
  const { mutateAsync: decideRefundRequest, isPending } = useDecidedRefundRequest();
  const { toast } = useNotification();

  const handleConfirm = () => {
    decideRefundRequest({
      refund_request_uuid: refund_request_uuid!,
      decision_comment: comment.trim(),
    }, {
      onSuccess: () => {
        toast({
          content: 'Reembolso aprovado!\nO usuário receberá um e-mail informando sobre a aprovação.',
          type: 'success',
        });
        onClose();
      },
      onError: () => {
        toast({
          content: 'Erro ao processar a solicitação. Tentar novamente em instantes.',
          type: 'error',
        });
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Aprovação do reembolso</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>
            Ao aprovar este pedido, você substitui a análise da Galena e autoriza o pagamento ao colaborador. Esta ação não pode ser desfeita.
          </Typography>

          <FormLabel>Comentário (opcional)</FormLabel>
          <TextField
            placeholder="Escreva a justificativa para o colaborador. Ela será enviada junto com o email de aprovação."
            multiline
            rows={4}
            fullWidth
            value={comment}
            onChange={(e) => setComment(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          disabled={isPending}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={handleConfirm}
          loading={isPending}
        >
          Aprovar reembolso
        </Button>
      </DialogActions>
    </Dialog>
  );
};
